<script setup>
/* eslint-disable vue/no-v-html */
import { computed, ref, onMounted, onUnmounted } from 'vue';
import ConfigurationRadioSelection from '../../ConfigurationRadioSelection';
import ConfigurationCheckSelection from '../../ConfigurationCheckSelection';
import { useMainStore } from '../../../store/index.js';

import '../../../styles/configurator-section.css';
import '../../../styles/configurator-selection.css';

const windowWidth = ref(window.innerWidth);

const store = useMainStore();

const emit = defineEmits(['select']);

const props = defineProps({
  items: {
    type: Object,
    default: null,
  },
});

const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const tyreSupplier = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'tyreSupplier');
});

const rimMaterial = computed(() => {
  if (!props.items) return null;
  return props.items.find(x => x.id === 'rimMaterial');
});
</script>

<template>
  <section
    v-if="props.items"
    id="wheels"
    class="configurator-section"
  >
    <h2>{{ $i18n('wheelsHeaderTitle') }}</h2>
    <div class="configurator-section__row">
      <ConfigurationRadioSelection
        v-if="tyreSupplier"
        v-model="store.selected.wheels[tyreSupplier.id]"
        :type="tyreSupplier.id"
        :options="tyreSupplier.options"
        :title="tyreSupplier.title"
        @select="emit('select', $event)"
      />
      <template v-if="rimMaterial">
        <ConfigurationRadioSelection
          v-if="rimMaterial.selectionType === 'radio'"
          v-model="store.selected.wheels[rimMaterial.id]"
          :type="rimMaterial.id"
          :options="rimMaterial.options"
          :title="rimMaterial.title"
          :options-container-style="{ height: '100%' }"
          @select="emit('select', $event)"
        />
        <ConfigurationCheckSelection
          v-if="rimMaterial.selectionType === 'checkbox'"
          v-model="store.selected.wheels[rimMaterial.id]"
          :type="rimMaterial.id"
          :title="rimMaterial.title"
          :options="rimMaterial.options"
          @select="emit('select', $event)"
        />
      </template>
    </div>
  </section>
</template>

<style scoped>
.sdds-divider-dark-vertical {
  height: var(--sdds-spacing-layout-72);
  margin-top: var(--sdds-spacing-element-48);
  align-self: center;
}

.configurator-section__image {
  max-width: 70%;
}

.configurator-section__image>img {
  max-width: 100%;
  object-fit: cover;
}

.is-side-image-custom-margin,
.side-image-custom-margin {
  margin-top: -12rem;
}

@media only screen and (max-width: 1294px) {
  .configurator-section__image>img {
    height: initial;
  }

  .is-side-image-custom-margin,
  .side-image-custom-margin {
    margin-top: -10rem;
  }
}

@media only screen and (max-width: 1000px) {
  .configurator-section__image {
    width: 90%;
  }

  .sdds-divider-dark-vertical {
    display: none;
  }

  .configurator-section__row {
    flex-direction: column;
    align-items: center;
  }
}
</style>
